module.exports = __webpack_public_path__ + "media/public/images/social/vkontakte-7e827f4c6ecbcb77588c902dc57e072c.svg";